import { TimePeriod } from "../../../../shared/enums/timePeriods.enum"

export interface EfficiencySummary {
    name: string,
    group: string,
    type: string,
    data: number[]
}

export interface UsageEfficiencySummary {
    name: string,
    data: number[]
}

export interface EfficiencySummaryRequest {
    organizationIds: string[],
    companyIds: string[],
    departmentIds: string[],
    modelIds: string[],
    activityIds: string[],
    forkliftIds: string[],
    startDate: string,
    endDate: string,
    reportType: TimePeriod
}

export interface MaintenanceSummaryResponse {
    totalMaintenanceMinutes: number;
}

export interface TagLookup {
    id: string;
    name: string;
    companyId?: string;
}

export interface EfficiencySummaryListRow {
    forkliftId: string;
    forkliftName: string;
    companyId: string;
    companyName: string;
    departmentId: string;
    departmentName: string;
    activity: string;
    model: string;
    tags: TagLookup[];
    startDate: string;
    endDate: string;
    expectedWorkingMinutes: number;
    workingMinutes: number;
    movementMinutes: number;
    idleMinutes: number;
    maintenanceMinutes: number;
    efficiencyPercentage: number;
}

export interface PagedResult<T> {
    page: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    items: T[];
}

export type SortDirection = 'Ascending' | 'Descending';

export enum EfficiencyBasis {
    Ignition = 1,
    Movement = 2
}

export interface EfficiencySummaryListRequest {
    organizationIds: string[];
    companyIds: string[];
    departmentIds: string[];
    modelIds: string[];
    activityIds: string[];
    forkliftIds: string[];
    tagIds: string[];
    startDate: string;
    endDate: string;
    page: number;
    pageSize: number;
    sortBy: string;
    sortDirection: SortDirection;
    efficiencyBasis?: EfficiencyBasis;
}

export interface EfficiencySummaryExportRequest {
    organizationIds: string[];
    companyIds: string[];
    departmentIds: string[];
    modelIds: string[];
    activityIds: string[];
    forkliftIds: string[];
    tagIds: string[];
    startDate: string;
    endDate: string;
    period: TimePeriod;
    efficiencyBasis?: EfficiencyBasis;
}

export interface EfficiencySummaryExportTotal {
    expectedWorkingMinutes: number;
    workingMinutes: number;
    movementMinutes: number;
    idleMinutes: number;
    maintenanceMinutes: number;
    efficiencyPercentage: number;
}

export interface EfficiencySummaryExportRow extends EfficiencySummaryExportTotal {
    forkliftId: string;
    forkliftName: string;
    companyName: string;
    departmentName: string;
    activity: string;
    model: string;
    tags: string[];
    periodStart: string;
    periodEnd: string;
}

export interface EfficiencySummaryExportResponse {
    rows: EfficiencySummaryExportRow[];
    total: EfficiencySummaryExportTotal;
}

export const TABLE_COLUMN_KEYS = [
    'forkliftName',
    'companyName',
    'departmentName',
    'activity',
    'model',
    'tags',
    'summary'
] as const;

export type TableColumnKey = typeof TABLE_COLUMN_KEYS[number];

export type VisibleColumnsState = Record<TableColumnKey, boolean>;

export type ColumnOrder = TableColumnKey[];

export const GROUP_BY_OPTIONS = ['none', 'companyName', 'departmentName', 'activity', 'model'] as const;
export type GroupByField = typeof GROUP_BY_OPTIONS[number];